import React from 'react';
import { CheckboxGroup, ControlSwitch } from "../Shared/Form";
import { actions, useStore } from "../store";
import { FormProvider, useForm } from "react-hook-form";
import { WizardButtons } from "../Wizard";
import { NextButton, PrevButton, ResetButton } from "../Shared/Buttons";
import { yupResolver } from "@hookform/resolvers/yup";
import { usageFormSchema } from "../schema";
import PropTypes from "prop-types";

const UsageStep = ({ stepName }) => {
  const [usageFormData, addUsageFormDataByKey, removeUsageFormDataByKey] =
    useStore(state => [state.usageFormData, state.addUsageFormDataByKey, state.removeUsageFormDataByKey])

  const [usageFormValue, setUsageFormValue, changeUsageFormValue ] =
    useStore(state => [state.usageFormValue, state.setUsageFormValue, state.changeUsageFormValue])
  const removeSuccessSteps = useStore(state => state.removeSuccessSteps)

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    resolver: yupResolver(usageFormSchema),
    defaultValues: usageFormValue,
  });

  const handleChange = (fieldName, value) => {
    changeUsageFormValue(fieldName, value)
    removeSuccessSteps(stepName)
  }

  const onSubmit = (data) => {
    setUsageFormValue(data);
    actions.handleWizardNextStep()
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <div className="card shadow-lg">
          <div className="card-header">
            <h3 className="card-title">
              Tell us how exactly do you use collected information, how can it be shared and what types of third-
              party services do you use.
            </h3>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold'>How do you use collected information?</p>
                <div className='d-flex flex-column'>
                  <CheckboxGroup
                    options={usageFormData.useCollectInfo}
                    name='useCollectInfo'
                    handleChange={handleChange}
                    isMoreAction={true}
                    handleAddMoreItem={addUsageFormDataByKey}
                    handleRemoveMoreItem={removeUsageFormDataByKey}
                  />
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold'>How do you share collected information?</p>
                <div className='d-flex flex-column'>
                  <CheckboxGroup
                    options={usageFormData.shareCollectInfo}
                    name='shareCollectInfo'
                    handleChange={handleChange}
                    isMoreAction={true}
                    handleAddMoreItem={addUsageFormDataByKey}
                    handleRemoveMoreItem={removeUsageFormDataByKey}
                  />
                </div>
              </div>
            </div>
            <div className='row mt-4'>
              <div className='col-12'>
                <p className='fw-bold'>Do you use any third-party services?</p>
              </div>

              <div className='col-lg-4 col-md-4 col-sm-12'>
                <div className="mb-3">
                  <ControlSwitch
                    labelOff='No'
                    labelOn='Yes'
                    name='isUseThirdPartyService'
                    handleChange={handleChange}
                  />
                </div>
              </div>
            </div>
            {
              usageFormValue.isUseThirdPartyService &&
              <div className='row mt-4'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold required'>What types of third-party services do you use?</p>

                  <div className='d-flex flex-column'>
                    <CheckboxGroup
                      options={usageFormData.thirdPartyService}
                      name='thirdPartyService'
                      handleChange={handleChange}
                      isMoreAction={true}
                      handleAddMoreItem={addUsageFormDataByKey}
                      handleRemoveMoreItem={removeUsageFormDataByKey}
                    />
                  </div>
                </div>
              </div>
            }
          </div>
          <div className='card-footer'>
            <WizardButtons>
              <>
                <PrevButton onClick={() => actions.handleWizardPrevStep()} />
                <ResetButton onClick={() => actions.handleWizardReset()} />
                <NextButton type='submit' />
              </>
            </WizardButtons>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

UsageStep.propTypes = {
  stepName: PropTypes.string.isRequired,
}

export default UsageStep;
